import ScrollReveal from '../ScrollReveal';
import { t } from '@/data/translations';
import type { Lang } from '@/pages/Index';

const Skills = ({ lang }: { lang: Lang }) => {
  const tr = t(lang).skills;
  return (
    <section id="skills" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-card">
      <div className="max-w-4xl mx-auto">
        {/* Compétences */}
        <div className="mb-20">
          <ScrollReveal>
            <div className="section-divider mb-8" />
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <h2 className="text-sm tracking-widest uppercase text-muted-foreground mb-12">{tr.sectionTitle}</h2>
          </ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {tr.categories.map((category, index) => (
              <ScrollReveal key={index} delay={(index + 1) * 100}>
                <div>
                  <h3 className="text-base md:text-lg font-medium text-foreground mb-4">{category.title}</h3>
                  <ul className="space-y-2">
                    {category.skills.map((skill, skillIndex) => (
                      <li key={skillIndex} className="list-item-hover text-muted-foreground text-sm md:text-base leading-relaxed pl-5 relative before:content-['–'] before:absolute before:left-0 before:text-primary/40">
                        {skill}
                      </li>
                    ))}
                  </ul>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>

        {/* Langues */}
        <div>
          <ScrollReveal>
            <div className="section-divider mb-8" />
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <h2 className="text-sm tracking-widest uppercase text-muted-foreground mb-12">{tr.languagesTitle}</h2>
          </ScrollReveal>
          <div className="flex flex-wrap gap-x-12 gap-y-4">
            {tr.languages.map((lang, index) => (
              <ScrollReveal key={index} delay={(index + 1) * 100}>
                <div className="flex items-baseline gap-3">
                  <span className="text-base md:text-lg font-medium text-foreground">{lang.name}</span>
                  <span className="text-sm md:text-base text-muted-foreground">{lang.level}</span>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
